import React from 'react';
import Select, { MultiValue, ActionMeta } from 'react-select';

import { SelectOption } from './config';

type Props = {
  options: SelectOption[];
  selectedOptions?: MultiValue<SelectOption>;
  placeholderText?: string;
  onSelectionChange: (selectedOptions: MultiValue<SelectOption>) => void;
};

const MultiSelectDropdown = ({
  options,
  selectedOptions,
  placeholderText,
  onSelectionChange,
}: Props) => {
  function handleOnSelectionChange(
    newValue: MultiValue<SelectOption>,
    actionMeta: ActionMeta<SelectOption>,
  ) {
    onSelectionChange(newValue);
  }

  return (
    <Select
      // className={`custom-360-dropdown ${styles.mw250} px-2`}
      options={options}
      isMulti={true}
      // allowSelectAll={true}
      value={selectedOptions}
      onChange={handleOnSelectionChange}
      hideSelectedOptions={true}
      controlShouldRenderValue={true}
      // styles={colorStyles}
      aria-label="interval"
      aria-describedby="intervalLabel"
      placeholder={placeholderText ? placeholderText : '...'}
      closeMenuOnSelect={false}
      menuPortalTarget={document.body}
      styles={{
        control: (provided, _) => ({
          ...provided,
          cursor: 'pointer',
        }),
        option: (provided, _) => ({
          ...provided,
          cursor: 'pointer',
        }),
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
};

export default MultiSelectDropdown;
